export default __webpack_public_path__ + "static/media/button_point-on.ab183305.svg";